import { c as _c } from "react/compiler-runtime";
import { Trans } from 'react-i18next';
import { MainLayout } from '../../MainLayout';
import { PageHeading } from '../../layout/PageHeading';
import { PianoIdentity } from '../../layout/PianoIdentity';
import { PrintButton } from '../../layout/PrintButton';
import { DesignStepsBar } from '@/components/design/steps/DesignStepsBar';
import { useDesignedKeyboard } from '../../../hooks/keyboard/use-designed-keyboard';
import { usePrintLandscape } from '@/hooks/use-print-page-size';
import { useTranslation } from '@/hooks/use-translation';
import { TouchWeightPreview } from '@/components/design/TouchWeightPreview';
export const DesignTouchWeightPreviewPage = () => {
  const $ = _c(14);
  const designedKeyboard = useDesignedKeyboard();
  const {
    t
  } = useTranslation();
  usePrintLandscape();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><PianoIdentity /><PrintButton /></>;
    t1 = <DesignStepsBar currentStepId="preview" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <em className="ptl-accent">Preview</em>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] !== t) {
    t3 = <Trans t={t} i18nKey="Touch Weight <1>Preview</1>">Touch Weight {t2}</Trans>;
    t4 = t("The touch you get once your design is applied, next to the piano as it stands. Friction stays as you measured it.");
    $[3] = t;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <PageHeading title={t3} lede={t4} />;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== designedKeyboard) {
    t6 = <TouchWeightPreview designedKeyboard={designedKeyboard} />;
    $[9] = designedKeyboard;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <MainLayout headerRight={t0}>{t1}{t5}{t6}</MainLayout>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};